import { createAsyncThunk } from '@reduxjs/toolkit';
import api from '../services/api';
import { createWrapperPayload, wrapperConstants } from '../services/wrapper-api';

interface FetchParams {
  wellId: number;
  endDate: string;
  startDate?: string;
}

let lastFetchParams: FetchParams = {
  wellId: 0,
  endDate: '',
  startDate: '',
};

export const fetchPumpCheckerEvents = createAsyncThunk(
  'asset/fetchEvents',
  async (params: FetchParams, thunkAPI) => {
    try {
      const requestPayload = createWrapperPayload(
        'GET',
        `/pumpchecker/Lookup/GetWellEvents?wellId=${params.wellId}&to=${params.endDate}`,
      );
      const response = await api.post(wrapperConstants.router, requestPayload);
      return response.data || [];
    } catch (error: any) {
      console.error('Error fetching asset downtime and shutdown data:', error);
      return thunkAPI.rejectWithValue(error.message || 'Failed to fetch asset downtime data');
    }
  },
  {
    condition: (params) => {
      const currentParams = lastFetchParams;
      // Only fetch if params have changed
      if (currentParams && currentParams.wellId === params.wellId && currentParams.endDate === params.endDate) {
        return false; // Skip fetch
      }
      lastFetchParams = params;
      return true; // Proceed with fetch
    },
  },
);
